import KngCommentAuditContent from './src/main';

/* istanbul ignore next */
KngCommentAuditContent.install = function(Vue) {
  Vue.component(KngCommentAuditContent.name, KngCommentAuditContent);
};

export default KngCommentAuditContent;
